import { CommonEnums } from 'src/app/shared/common.enums';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { ObjectWrapperUtil } from 'src/app/shared/utils/object.wrapper.util';
import { ErrorCdsEnums } from 'src/app/shared/errorcds.enums';
import { LAttribute } from 'src/app/shared/models/domain/lattribute';
import { LAttributesUtil } from './lattributes.util';
import { TransformsUtil } from '../../../modules/design/transforms/transforms.util';

export class LAttributeTabulator {
    private static instance: LAttributeTabulator;

    static getInstance() {
        if (!LAttributeTabulator.instance) {
            LAttributeTabulator.instance = new LAttributeTabulator();
        }

        return LAttributeTabulator.instance;
    }

    columns: Array<any>;
    objectWrapperUtil: ObjectWrapperUtil;

    /**
      * LAttributeTabulator is a singleton class, so use LAttributeTabulator.getInstance() method instead of creating new LAttributeTabulator().
      */
    private constructor() {
        this.columns = new Array<any>();
    }

    getCheckBoxColumn(): any {
        let column: any = {};

        column.formatter = "rowSelection"
        column.width = 40;
        column.align = "center";
        column.titleFormatter = "rowSelection"
        column.resizableColumn = false;
        column.headerSort = false
        return column;
    }

    getSrt_Order(): any {
        let column: any = {};

        column.title = "#";
        column.field = 'srt_Order';
        column.headerSort = false;
        column.width = 50;

        column.formatter = function (cell) {
            return cell.getRow()._row.data.srt_Order + 1;
        }

        return column;
    }

    getLAttr_Id(): any {
        let column: any = {};

        column.title = "Id";
        column.field = 'lAttr_Id';
        column.width = 100;
        column.headerSort = false;
        column.visible = false;

        return column;
    }

    getLAttrNm(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Alias Name";
        column.field = "lAttrNm";
        column.width = 250;
        column.headerSort = false;

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE)
            return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            let oldLAttrNm: string = lAttribute.lAttrNm;

            let editor = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                lAttribute.lAttrNm = editor.value;

                if (editor.value != oldLAttrNm ||
                    ObjectWrapperUtil.getInstance().hasWhiteSpace(lAttribute.lAttrNm)) {
                    if (editor.value == '') {
                        lAttribute.lAttrNm = oldLAttrNm;
                        editor.value = oldLAttrNm;
                    } else if (objectWrapper.subNames.indexOf(editor.value.toUpperCase()) != -1) {
                        lAttribute.lAttrNm = oldLAttrNm;
                        editor.value = oldLAttrNm;
                    } else {
                        setTimeout(() => {
                            ObjectWrapperUtil.getInstance().updateSubName(editor.value, oldLAttrNm, objectWrapper);

                            if (objectWrapper.hasOwnProperty('designWrapper')) {
                                let oldFullName = objectWrapper.name + '.' + oldLAttrNm;
                                let newFullName = objectWrapper.name + '.' + lAttribute.lAttrNm;

                                TransformsUtil.getInstance().downStreamRename(oldLAttrNm, lAttribute.lAttrNm, oldFullName,
                                    newFullName, lAttribute.srt_Order, lAttribute.lAttr_Id, objectWrapper, objectWrapper.designWrapper);
                            }
                            objectWrapper.setChange_Ind();
                        });
                    }
                }

            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getSelectLAttrColumn(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Select Column";
        column.field = '';
        column.width = 200;
        column.headerSort = false;

        column.formatter = function (cell) {
            return LAttributesUtil.getInstance().getLAttributeName(cell.getRow()._row.data, objectWrapper);
        };

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE)
            return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            let table: any = cell.getTable();
            let Rows: any = cell.getRows
            let rowIndex = cell.getRow().getIndex();

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            for (let i: number = 0; i < objectWrapper.carryForwardAttributes.length; i++) {

                for (let j: number = 0; j < objectWrapper.carryForwardAttributes[i].items.length; j++) {
                    let option = document.createElement("option");

                    option.value = objectWrapper.carryForwardAttributes[i].items[j].name;//objectWrapper.carryForwardAttributes[i].items[j].attr_Id;
                    option.text = objectWrapper.carryForwardAttributes[i].items[j].name;

                    editor.appendChild(option);
                }

            }

            editor.value = LAttributesUtil.getInstance().getLAttributeName(cell.getRow()._row.data, objectWrapper);

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
               
                // lAttribute.lnk_Attr_Id = editor.value;
                let index = editor.value.indexOf('.');
                let obj_Nm = editor.value.slice(0, index);
                let attr_Nm = editor.value.slice(index + 1, editor.value.length);


                for (let i: number = 0; i < objectWrapper.carryForwardAttributes.length; i++) {
                    let carryForwardAttribute: any = objectWrapper.carryForwardAttributes[i];
                    if (carryForwardAttribute.objNm == obj_Nm) {
                        lAttribute.lnk_Obj_Inst_Id = carryForwardAttribute.obj_Id;
                        for (let j: number = 0; j < carryForwardAttribute.items.length; j++) {
                            let attribute = carryForwardAttribute.items[j];
                            if (attribute.attrNm == attr_Nm) {
                                lAttribute.lnk_Attr_Id = attribute.attr_Id;

                        break;
                    }
                }

                        break;
                    }
                }
                success(lAttribute);
                    table.updateRow(rowIndex, lAttribute);
                    table.redraw(true);
                objectWrapper.doValidate();
            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getSelectColumn(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Select Column";
        column.field = '';
        column.width = 200;
        column.headerSort = false;

        column.formatter = function (cell) {
            return LAttributesUtil.getInstance().getLAttributeName(cell.getRow()._row.data, objectWrapper);
        };

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE)
            return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            let table: any = cell.getTable();
            let Rows: any = cell.getRows
            let rowIndex = cell.getRow().getIndex();

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            for (let i: number = 0; i < objectWrapper.carryForwardGroupAttributes.length; i++) {
                let option = document.createElement("option");

                option.value = objectWrapper.carryForwardGroupAttributes[i].name;
                option.text = objectWrapper.carryForwardGroupAttributes[i].name;

                editor.appendChild(option);
            }

            editor.value = LAttributesUtil.getInstance().getLAttributeName(cell.getRow()._row.data, objectWrapper);

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                // success(editor.value);
                // lAttribute.lnk_Attr_Id = editor.value;

                for (let i: number = 0; i < objectWrapper.carryForwardGroupAttributes.length; i++) {
                    let carryForwardGroupAttribute: any = objectWrapper.carryForwardGroupAttributes[i];

                    if (carryForwardGroupAttribute.name == editor.value) {
                        lAttribute.lnk_Obj_Inst_Id = carryForwardGroupAttribute.obj_Id;
                        lAttribute.lnk_Attr_Id = carryForwardGroupAttribute.attr_Id;
                        lAttribute.type = 'Group';
                        break;
                    }
                }

                success(lAttribute);

                    table.updateRow(rowIndex, lAttribute);
                    table.redraw(true);

                objectWrapper.doValidate();
            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }



    getAttrDTypNm(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Data Type";
        column.field = '';
        column.width = 100;
        column.headerSort = false;
        column.visible = objectWrapper.obj_Cd != "RLUP";

        column.formatter = function (cell) {
            return LAttributesUtil.getInstance().getLAttributeType(cell.getRow()._row.data, objectWrapper);
        }

        return column;
    }

    getDistKeyFlag(objectWrapper: ObjectWrapper, component: any = null, title: string = ''): any {
        let column: any = {};

        column.title = title != '' ? title : "Dist";
        column.field = 'distKeyFlag';
        column.width = 60;
        column.headerSort = false;
        column.formatter = function (cell) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            if (lAttribute.distKeyFlag == 0) {
                return '';

            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = lAttribute.distKeyFlag;

            return element;

        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            let editor = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<LAttribute> = cell._cell.column.cells;
            let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;
                editor.appendChild(option);
            }

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                lAttribute.distKeyFlag = parseInt(editor.value);
                objectWrapper.distKeyFlagChanged(lAttribute);
                if (component)
                    component.updateRefreshCountForLAttributes();
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }


        return column;
    }

    getPartFlag(objectWrapper: ObjectWrapper, component: any = null): any {
        let column: any = {};
        column.title = "Partition";
        column.field = 'partitionflag';
        column.width = 80;
        column.headerSort = false;


        column.formatter = function (cell, formatterParams, onRendered) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            if (lAttribute.partitionflag == 0)
                return '';

            return lAttribute.partitionflag;
        }


        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<LAttribute> = cell._cell.column.cells;
            let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);

            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;

                editor.appendChild(option);
            }
            editor.value = lAttribute.partitionflag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                lAttribute.partitionflag = editor.value;
                objectWrapper.partitionflagChanged(lAttribute);
                if (component)
                    component.updateRefreshCountForLAttributes();
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }
    getClusterKeyFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Cluster";
        column.field = 'clusterFlag';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            if (lAttribute.clusterFlag == 0)
                return '';

            return lAttribute.clusterFlag;
        }

        // "<div ng-if='dataItem.isEditable == \"N\" '><span class='italic' ng-if='dataItem.clusterFlag!=0'>{{dataItem.clusterFlag}}</span></div>" +
        // "<div ng-if='dataItem.isEditable != \"N\" '><input kendo-drop-down-list text-field='\"value\"' value-field='\"value\"' "
        // + " k-data-source='{{objectWrapper.getDistKeyFlagList()}}' data-ng-model='dataItem.clusterFlag' k-value='dataItem.clusterFlag' "
        // + " ng-change='objectWrapper.clusterFlagChanged(dataItem)' /></div> ";

        return column;
    }

    getOrgKeyFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Org";
        column.field = "orgKeyFlag";
        column.width = 70;
        column.headerSort = false;

        column.formatter = function (cell) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            if (lAttribute.orgKeyFlag == 0)
                return '';

            return lAttribute.orgKeyFlag;
        }

        // "<input kendo-drop-down-list text-field='\"value\"' value-field='\"value\"' "
        //         + " k-data-source='{{objectWrapper.getAttributesLengthList()}}' data-ng-model='dataItem.orgKeyFlag' k-value='dataItem.orgKeyFlag' " 
        //         + " ng-change='DILAttributes.orgKeyFlagChanged(dataItem, lAttributes, objectWrapper )'/>"

        return column;
    }


    getOrderBy(objectWrapper: ObjectWrapper, component: any = null): any {
        let column: any = {};

        column.title = "Order";
        column.field = "orderBy";
        column.width = 70;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            if (lAttribute.orderBy == 0) {
                return '';
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = lAttribute.orderBy;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            let editor = document.createElement("select");
            editor.id = "mySelect";

            // let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            let values: Array<any> = objectWrapper.getAttributesLengthList();
            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;
                editor.appendChild(option);
            }

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                lAttribute.orderBy = parseInt(editor.value);
                if (component)
                    component.updateRefreshCountForLAttributes();
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }


    getLAttrmaxFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Max";
        column.field = "maxFlag";
        column.width = 100;
        column.headerSort = false;

        // maxFlag.hidden = !isMax;

        // maxFlag.template = "<span class=''><input type='checkbox' ng-if='::!dataItem.hidemaxFlag' id='{{::dataItem.attr_Id}}'"
        //             + " ng-model='dataItem.maxFlag' ng-true-value=\"'Y'\" ng-false-value=\"'N'\" ng-change='objectWrapper.setPrecValue(dataItem); objectWrapper.setChange_Ind()' "
        //             + " ng-disabled='::(objectWrapper.nativeDbTyp_Id == 19 || objectWrapper.nativeDbTyp_Id == 20 || readOnlyAttributes || ListFactory.isDiffOpened || dataItem.isMaxEditFlag ==\"Y\")' /></span> "

        //             + " <label ng-if='::!dataItem.hidemaxFlag' class='margin-left-10' for='{{::dataItem.attr_Id}}'></label>"
        // maxFlag.editor = "<span class=''><input type='checkbox' ng-if='!dataItem.hidemaxFlag' id='{{dataItem.attr_Id}}'" 
        //             + " ng-model='dataItem.maxFlag' ng-true-value=\"'Y'\" ng-false-value=\"'N'\" ng-change='objectWrapper.setPrecValue(dataItem); objectWrapper.setChange_Ind()'  ng-disabled = 'dataItem.isMaxEditFlag ==\"Y\"' /> </span>"

        //             + " <label ng-if='!dataItem.hidemaxFlag' class='margin-left-10' for='{{dataItem.attr_Id}}'></label>";

        return column;
    }

    getLAttrPrec(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Prec";
        column.field = '';
        column.width = 90;
        column.headerSort = false;
        column.visible = objectWrapper.obj_Cd != "RLUP";

        column.formatter = function (cell) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            // if (!LAttributesUtil.getInstance().showPrec(objectWrapper, lAttribute))
            //     return '';

            return LAttributesUtil.getInstance().getLAttributePrec(lAttribute, objectWrapper)
        }

        return column;
    }

    getLAttrScale(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Scale";
        column.field = '';
        column.width = 90;
        column.headerSort = false;
        column.visible = objectWrapper.obj_Cd != "RLUP";

        column.formatter = function (cell) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            // if (!LAttributesUtil.getInstance().showScale(objectWrapper, lAttribute))
            //     return '';

            return LAttributesUtil.getInstance().getLAttributeScale(lAttribute, objectWrapper)
        }

        return column;
    }

    getLAttrType(objectWrapper: any): any {
        let column: any = {};

        column.title = "Type";
        column.field = 'type';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            if (lAttribute.type == '')
                return '';

            return lAttribute.type;
        };

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE)
            return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;
            let table: any = cell.getTable();
            let Rows: any = cell.getRows
            let rowIndex = cell.getRow().getIndex();

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            for (let i: number = 0; i < objectWrapper.object.type.length; i++) {
                let option = document.createElement("option");

                option.value = objectWrapper.object.type[i];
                option.text = objectWrapper.object.type[i];

                editor.appendChild(option);
            }

            editor.value = lAttribute.type;

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);

                for (let i: number = 0; i < objectWrapper.object.type.length; i++) {
                    let functionList: any = objectWrapper.object.type[i];

                    if (functionList.attr_Id == editor.value) {
                        lAttribute.type = functionList;

                        break;
                    }
                }

                if (lAttribute.type == 'Group')
                    lAttribute.function = '';
                else
                    lAttribute.function = objectWrapper.object.functions[0];

                setTimeout(() => {
                    table.updateRow(rowIndex, lAttribute);
                    table.redraw(true);
                });

                objectWrapper.doValidate();
            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }
        return column;
    }

    getLAttrFunction(objectWrapper: any): any {
        let column: any = {};

        column.title = "Functions";
        column.field = 'function';
        column.width = 150;
        column.headerSort = false;


        column.formatter = function (cell) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            if (lAttribute.function == '' || lAttribute.type == 'Group')
                return '';

            return lAttribute.function;
        };

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE)
            return column;



        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let lAttribute: LAttribute = cell.getRow()._row.data;

            if (lAttribute.type == 'Group')
                return;

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            for (let i: number = 0; i < objectWrapper.object.functions.length; i++) {
                let option = document.createElement("option");

                option.value = objectWrapper.object.functions[i];
                option.text = objectWrapper.object.functions[i];

                editor.appendChild(option);
            }

            editor.value = lAttribute.function;

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);

                for (let i: number = 0; i < objectWrapper.object.functions.length; i++) {
                    let functionType: any = objectWrapper.object.functions[i];

                    if (functionType.attr_Id == editor.value) {
                        lAttribute.lnk_Obj_Inst_Id = functionType;

                        break;
                    }
                }

                objectWrapper.doValidate();
            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }
        return column;
    }

    getValid_Cd(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "!";
        column.width = 50;
        column.field = 'valid_Cd';
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            if (cell.getValue() == "0") {
                return '';
            }
            return "<i title='" + ErrorCdsEnums.errorcds[cell.getValue()] + "' class='text-danger fs-9 fa fa-circle hand'></i>";
        }

        return column;
    }

    getUpiFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "UPI";
        column.field = "upiFlag";
        column.width = 50;
        column.headerSort = false;

        // upiFlag.editor = "<input kendo-drop-down-list text-field='\"value\"' value-field='\"value\"' "
        //         + " k-data-source='{{objectWrapper.getAttributesLengthList()}}' data-ng-model='dataItem.upiFlag' k-value='dataItem.upiFlag' " 
        //         + " ng-change='DILAttributes.upiFlagChanged(dataItem, lAttributes, objectWrapper )' />";

        if (objectWrapper.mode_Ind == CommonEnums.mode_Ind.WRITE) {
            column.editor = "select";
            column.editorParams = function (data) {
                let attributes: Array<any> = data._cell.column.cells;
                let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
                let values: Array<number>;
                values = new Array<number>();
                attributesList.forEach(function (item) {
                    values.push(item.value);
                })
                return values;
            }
        };

        return column;
    }

    getNupiFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "NUPI";
        column.width = 50;
        column.field = "nupiFlag";
        column.headerSort = false;

        // "<input kendo-drop-down-list text-field='\"value\"' value-field='\"value\"' "
        //         + " k-data-source='{{objectWrapper.getAttributesLengthList()}}' data-ng-model='dataItem.nupiFlag' k-value='dataItem.nupiFlag' "
        //         + " ng-change='DILAttributes.nupiFlagChanged(dataItem, lAttributes, objectWrapper )' />";

        if (objectWrapper.mode_Ind == CommonEnums.mode_Ind.WRITE) {
            column.editor = "select";
            column.editorParams = function (data) {
                let attributes: Array<any> = data._cell.column.cells;
                let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
                let values: Array<number>;
                values = new Array<number>();
                attributesList.forEach(function (item) {
                    values.push(item.value);
                })
                return values;
            }
        };

        return column;
    }

    getUsiFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "USI";
        column.field = "usiFlag";
        column.width = 50;
        column.headerSort = false;

        // "<input kendo-drop-down-list text-field='\"value\"' value-field='\"value\"' "
        // + " k-data-source='{{objectWrapper.getAttributesLengthList()}}' data-ng-model='dataItem.usiFlag' k-value='dataItem.usiFlag'"
        // + " ng-change='DILAttributes.usiFlagChanged(dataItem, lAttributes, objectWrapper )' />";

        if (objectWrapper.mode_Ind == CommonEnums.mode_Ind.WRITE) {
            column.editor = "select";
            column.editorParams = function (data) {
                let attributes: Array<any> = data._cell.column.cells;
                let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
                let values: Array<number> = new Array<number>();
                attributesList.forEach(function (item) {
                    values.push(item.value);
                })
                return values;
            }
        };

        return column;
    }

    getNusiFlag(objectWrapper: ObjectWrapper = null): any {
        let column: any = {};

        column.title = "NUSI";
        column.field = "nusiFlag";
        column.width = 50;
        column.headerSort = false;

        // "<input kendo-drop-down-list text-field='\"value\"' value-field='\"value\"' "
        //         + " k-data-source='{{objectWrapper.getAttributesLengthList()}}' data-ng-model='dataItem.nusiFlag'  k-value='dataItem.nusiFlag' "
        //         + " ng-change='DILAttributes.nusiFlagChanged(dataItem, lAttributes, objectWrapper )' />";

        return column;
    }

    getClevel(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Level";
        column.field = "clevel";
        column.width = 100;
        column.headerSort = false;

        return column;
    }

    getOccurs(objectWrapper: ObjectWrapper, title: string = '') {
        let column: any = {};

        column.field = "occurs";
        column.title = title ? title : "Occurs";
        column.width = 130;
        column.headerSort = false;

        // occurs.template = "<span ng-hide='databaseWrapper.hideOccurs(dataItem)'>{{dataItem.occurs == -1 ? 'Unbounded' : dataItem.occurs}}</span>";
        // occurs.editor = "<input kendo-numeric-text-box k-min='-2147483646' k-max='2147483646' k-ng-model='dataItem.occurs' " 
        //             + " ng-focus='DIKeyboard.setFocusOn(\"inputText\");' />";

        return column;
    }
}